var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchPeopleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    filter: "url(#filter0_d_1285_594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_3_Recruitment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.7926 15.0319V50.1881C63.7926 56.384 58.7697 61.4069 52.5738 61.4069H17.4258C11.2299 61.4069 6.20703 56.384 6.20703 50.1881V15.0319C6.20703 8.83597 11.2299 3.81311 17.4258 3.81311H52.5739C58.7698 3.81311 63.7926 8.83597 63.7926 15.0319Z",
    fill: "white",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.7393 36.5865C24.0166 36.5865 22.6221 37.9869 22.6221 39.7037C22.6221 41.4264 24.0166 42.8268 25.7393 42.8268C27.4561 42.8268 28.8564 41.4264 28.8564 39.7037C28.8564 37.9869 27.4561 36.5865 25.7393 36.5865ZM25.7393 41.6549C24.667 41.6549 23.7939 40.7819 23.7939 39.7037C23.7939 38.6315 24.667 37.7584 25.7393 37.7584C26.8115 37.7584 27.6846 38.6315 27.6846 39.7037C27.6846 40.7819 26.8115 41.6549 25.7393 41.6549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5439 48.569V50.7721C30.5439 51.1002 30.2861 51.358 29.958 51.358H21.5205C21.1924 51.358 20.9346 51.1002 20.9346 50.7721V48.569C20.9346 45.9205 23.0908 43.7643 25.7393 43.7643C28.3877 43.7643 30.5439 45.9205 30.5439 48.569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.4482 48.569V50.7721C41.4482 51.1002 41.1846 51.358 40.8623 51.358H32.4189C32.0967 51.358 31.833 51.1002 31.833 50.7721V48.569C31.833 45.9205 33.9893 43.7643 36.6377 43.7643C39.292 43.7643 41.4482 45.9205 41.4482 48.569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.6377 36.5865C34.9209 36.5865 33.5205 37.9869 33.5205 39.7037C33.5205 41.4264 34.9209 42.8268 36.6377 42.8268C38.3604 42.8268 39.7607 41.4264 39.7607 39.7037C39.7607 37.9869 38.3604 36.5865 36.6377 36.5865ZM36.6377 41.6549C35.5654 41.6549 34.6924 40.7819 34.6924 39.7037C34.6924 38.6315 35.5654 37.7584 36.6377 37.7584C37.7158 37.7584 38.5889 38.6315 38.5889 39.7037C38.5889 40.7819 37.7158 41.6549 36.6377 41.6549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M48.1981 34.7702L42.1747 29.1803C43.0243 27.5807 43.452 25.776 43.3817 23.9128C43.1649 18.1178 38.2958 13.6471 32.5536 13.8698C23.3485 14.2155 19.0008 25.612 25.8446 31.9577C29.3778 35.2389 34.5751 35.6198 38.5067 33.1413L44.5301 38.7311C45.62 39.7389 47.3309 39.6803 48.3446 38.5846C49.3583 37.4948 49.2938 35.7897 48.1981 34.7702ZM37.8739 29.3444C35.0848 32.069 30.6317 32.0104 27.9071 29.2272C23.5829 24.8034 26.7001 17.2565 32.9461 17.2565C39.2567 17.2565 42.3622 24.9557 37.8739 29.3444ZM47.4833 37.7878C46.9032 38.4147 45.9364 38.4381 45.327 37.8698L39.4794 32.444C40.3524 31.7409 40.909 31.1432 41.5536 30.2057L47.4012 35.6315C48.0223 36.2057 48.0575 37.1667 47.4833 37.7878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.5343 20.2037C34.1417 19.7994 33.6202 19.5768 33.0577 19.5651H33.0284C32.4777 19.5651 31.962 19.776 31.5636 20.1627C31.1652 20.5553 30.9366 21.0768 30.9308 21.6393C30.9249 22.2018 31.1359 22.7291 31.5284 23.1334C31.9152 23.5319 32.4425 23.7604 33.005 23.7662H33.0343C33.5792 23.7662 34.1007 23.5553 34.4933 23.1686C34.8976 22.7819 35.1202 22.2545 35.132 21.692C35.1378 21.1354 34.9269 20.6022 34.5343 20.2037ZM33.0284 22.5944C33.0284 22.5944 33.0226 22.5944 33.0167 22.5944C32.5011 22.5885 32.0968 22.1608 32.1027 21.6569C32.1085 21.1471 32.5245 20.7369 33.0284 20.7369H33.046C33.5616 20.7487 33.9659 21.1705 33.9601 21.6803C33.9542 22.1901 33.5382 22.5944 33.0284 22.5944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.9991 24.0826C31.0655 24.0826 29.6651 25.6002 29.6417 27.3522L29.63 28.3717C29.6241 28.6998 29.8819 28.9635 30.2101 28.9694L35.6593 29.0397H35.6651C35.9874 29.0397 36.2452 28.7819 36.2511 28.4655L36.2628 27.4401C36.2921 25.6119 34.8272 24.1061 32.9991 24.0826ZM35.0851 27.8619L30.8077 27.8033L30.8136 27.3639C30.8312 26.1862 31.8038 25.2369 32.9815 25.2545C34.1651 25.2721 35.1085 26.2448 35.0909 27.4225L35.0851 27.8619Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1285_594",
    x: 0.0999999,
    y: -0.290015,
    width: 73.8,
    height: 73.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_594",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPeopleIcon);
export default __webpack_public_path__ + "static/media/search-people-icon.ee2c30fd08e309358835cfc2fe375733.svg";
export { ForwardRef as ReactComponent };